const ArrowDown = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.2 11.2"><path d="M9.1 11.2L0 2.2 2.2 0l6.9 7L16 0l2.2 2.2-9.1 9z"/></svg>`;

export { ArrowDown as A };

//# sourceMappingURL=icon.js.map